import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoggingService {
  logError(message: any) {
    console.error(message);
  }
}
